module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Admin Index")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-24"
  }, [_c('div', {
    staticClass: "well"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "to": "/admin/accounts",
      "tag": "button"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-user"
  }), _vm._v(" \n                        User Accounts\n                    ")])], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "to": "/admin/db",
      "tag": "button"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-floppy-disk"
  }), _vm._v(" \n                        Database Admin\n                    ")])], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "to": "/admin/convergence",
      "tag": "button"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-cog"
  }), _vm._v(" \n                        Convergence Admin\n                    ")])], 1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "to": "/admin/notifications",
      "tag": "button"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-exclamation-sign"
  }), _vm._v("\n                        Notifications\n                    ")])], 1), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "to": "/admin/modellocks",
      "tag": "button"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-lock"
  }), _vm._v("\n                        Model Locks\n                    ")])], 1), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "to": "/admin/siteinfo",
      "tag": "button"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-info-sign"
  }), _vm._v("\n                        Site Information\n                    ")])], 1), _vm._v(" "), _vm._m(5)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-20"
  }, [_c('p'), _c('header', [_vm._v("User account management")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-20"
  }, [_c('p'), _c('header', [_vm._v(" Database administration")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-20"
  }, [_c('p'), _c('header', [_vm._v(" Convergence administration")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-20"
  }, [_c('p'), _c('header', [_vm._v(" Create user notifications")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-20"
  }, [_c('p'), _c('header', [_vm._v(" Manage model edit locks")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-20"
  }, [_c('p'), _c('header', [_vm._v(" Displays site version information")]), _vm._v(" "), _c('p')])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-40282af5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40282af5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/admin/admin-index.vue.html
// module id = 1096
// module chunks = 0